import Icon from "@ant-design/icons";
import { jsx as _jsx } from "react/jsx-runtime";
export function RightOutlined(props) {
  return /*#__PURE__*/_jsx(Icon, {
    ...props,
    viewBox: "0 0 512 512",
    children: /*#__PURE__*/_jsx("polyline", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "48px"
      },
      points: "204 112 348 256 204 400"
    })
  });
}